// client/src/components/FeaturedProducts.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import FeaturedProductCard from './FeaturedProductCard';
import './FeaturedProducts.css';

const FeaturedProducts = () => {
  const [row1Products, setRow1Products] = useState([]);
  const [row2Products, setRow2Products] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/products`)
      .then(response => response.json())
      .then(data => {
        const dialysisProducts = data.filter(p => p.category === 'Dialysis Supplies');
        setRow1Products(dialysisProducts.slice(0, 5));
        setRow2Products(dialysisProducts.slice(5, 10));
      })
      .catch(error => console.error('Error fetching products:', error));
  }, []);

  if (row1Products.length === 0) {
    return null;
  }

  return (
    // We use the same 'AboutSnippet' section style as a base for consistency
    <section className="featured-products-section">
      <div className="featured-products-wrapper">
        <div className="container">
          <h2 className="section-title">Specialized Dialysis Solutions</h2>
          <p className="section-subtitle">
            Hover over any product to pause and see details. Click to request a quote.
          </p>
        </div>

        <div className="product-scroller">
          <div className="product-track">
            {row1Products.map(product => <FeaturedProductCard key={`${product.id}-a`} product={product} />)}
            {row1Products.map(product => <FeaturedProductCard key={`${product.id}-b`} product={product} />)}
          </div>
        </div>

        {row2Products.length > 0 && (
          <div className="product-scroller">
            <div className="product-track track-reverse">
              {row2Products.map(product => <FeaturedProductCard key={`${product.id}-c`} product={product} />)}
              {row2Products.map(product => <FeaturedProductCard key={`${product.id}-d`} product={product} />)}
            </div>
          </div>
        )}

        <div className="container see-all-container">
          <Link to="/products/dialysis-supplies" className="btn btn-secondary">
              Explore All Dialysis Products
          </Link>
        </div>
      </div>
      {/* --- END: NEW WRAPPER --- */}
    </section>
  );
};

export default FeaturedProducts;